import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";

function CustomersList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [makes, setMakes] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getMakes();
    const interval = setInterval(() => {
      getMakes();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getMakes = () => {
    axios.get(URL_API + "auth/admin/vehicles").then((response) => {
      console.log(response);
      if (response.data.status === 200) {

        setMakes(response.data.vehicles);
      }
    });
  };

  const destroyMaker = (id) => {

    axios
      .post(URL_API + `auth/admin/delete-vehicles/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/makes");
          toast.success("Maker Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getMakes();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Customer List</CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <a href={`/admin/maker/create`}>
                  <strong>Add Maker + </strong>
                </a>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Icon</th>
                      <th>Slug</th>
                      <th>Hero Image</th>
                      <th>Description</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      makes.map(
                        (make, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{make?.vehicle_name}</td>
                              <td><img height="80" width="80" src={IMAGE_URL+ make?.image} /></td>
                              <td>{make?.slug}</td>
                              <td><img height="80" width="150" src={IMAGE_URL+ make?.hero_image} /></td>
                              <td>{make?.description?.substring(0, 80)}...</td>
                              <td>
                                {moment(make?.created_at).format(
                                  " DD MMMM,YYYY"
                                )}
                              </td>
                              <td>
                                {/* <a style={{color:"#77ac54"}} href={`article/detail/${tag.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                                <a  href={`maker/edit/${make.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a style={{color:"red"}} onClick={() => destroyMaker(make.id)}>
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        }
                        // )
                      )
                    }
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CustomersList;
